import { useAPIQuery, ImagesDraftApi } from "melco-shared-logic";

export const useBlankPictureReferences = (blankPictureId: string) => {
  return useAPIQuery(
    ImagesDraftApi,
    ["blankPictureReferences", blankPictureId],
    async (api) => api.userImageReferences({ id: blankPictureId })
  );
};
